import { clickCreateIntegration } from './click-create-integration';
import { clickNewIntegration } from './click-new-integration';
import { creatingIntegration } from './creating-integration';
import { fallbackText, integrationForm, parameters, paramsHideField, paramsRemoveField, rulename } from './form';
import { clickAProvider, providerOptions, requestingNewProvider } from './options';

let createSteps = [
  creatingIntegration,
  clickNewIntegration,
  providerOptions,
  requestingNewProvider,
  clickAProvider,
  integrationForm,
  rulename,
  parameters,
  paramsHideField,
  paramsRemoveField,
  fallbackText,
  clickCreateIntegration
];

export const CREATE_STEPS = createSteps;
